import { FILTERINFO } from '../utils'

export default {
	input: '',
	placeholder: 'What needs to be done?',
	todos: [],
	filter: FILTERINFO.All,
}
